module.exports = "#define SHADER_NAME PHASER_BITMAP_MASK_VS\r\n\r\nprecision mediump float;\r\n\r\nattribute vec2 inPosition;\r\n\r\nvoid main()\r\n{\r\n    gl_Position = vec4(inPosition, 0.0, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./renderer/webgl/shaders/BitmapMask.vert
// module id = 536
// module chunks = 0